import React from 'react';
import { Helmet } from 'react-helmet';

interface CustomCssSectionProps {
  showCustomCss?: boolean;
  customCss?: string;
}

const CustomCssSection: React.FC<CustomCssSectionProps> = ({
  showCustomCss = false,
  customCss = ''
}) => {
  if (!showCustomCss || !customCss || !customCss.trim()) {
    return null;
  }

  return (
    <Helmet>
      <style type="text/css">
        {customCss}
      </style>
    </Helmet>
  );
};

export default CustomCssSection;